import { useRef, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { Semen } from '@/rtk-query.gql';
import { SemenDto } from '@/services/semen-service/types';

import { NewSemenTransactionForm } from '../new-semen-transaction-form';
import { NewSemenTransactionFormValues } from '../new-semen-transaction-form/schema';

type AddTransactionDialogProps = {
  gridRef?: React.RefObject<AgGridReact>;
  visible: boolean;
  onHide: () => void;
  semenId: string;
  semen?: SemenDto | null;
  semens?: SemenDto[];
  onSuccess?: () => void;
};

export const AddTransactionDialog = ({
  gridRef,
  visible,
  onHide,
  semenId,
  semen,
  semens,
  onSuccess,
}: AddTransactionDialogProps) => {
  const { t } = useTranslation();
  const dialogRef = useRef<Dialog>(null);
  const [dialogContainer, setDialogContainer] = useState<HTMLElement>();
  const handleSuccess = (data: NewSemenTransactionFormValues) => {
    gridRef?.current?.api?.refreshInfiniteCache();
    onSuccess?.();
  };

  return (
    <Dialog
      ref={dialogRef}
      header={t('semenTransaction.newSemenTransaction')}
      visible={visible}
      onHide={onHide}
      modal
      className="w-[1000px] max-w-[95vw]"
      onShow={() =>
        setDialogContainer(dialogRef.current?.getMask() ?? undefined)
      }
    >
      <NewSemenTransactionForm
        semenId={semenId}
        semen={semen as Semen | undefined}
        semens={semens}
        onSuccess={handleSuccess}
        onCancel={onHide}
        calendarContainer={dialogContainer}
      />
    </Dialog>
  );
};
